// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1orcQ","header":"MessagesList_header__1HwhI","chat":"MessagesList_chat__2p0ED"};